
import {defaults as defaultControls, Control} from 'ol/control';
import {CLASS_CONTROL, CLASS_UNSELECTABLE} from 'ol/css';

import {getCenter} from 'ol/extent';
import Point from "ol/geom/Point";
import {listen} from "ol/events";
import EventType from "ol/events/EventType";

import {contains} from 'ol/format/filter.js';
import {WFS, GeoJSON} from 'ol/format.js';
import {unByKey} from "ol/Observable";
import Overlay from "ol/Overlay";


require('es6-promise').polyfill();

export class FeatureInfoControl extends Control {
    isActive=false;
    popupContent=null;
    overlay=null;
    currentFeatureId=null;
    clickedCoordinates=null;

    popupFeatures=[];
    attributeHeader=["Intenzita EMP v pásme","[V/m]","Limitné hodnoty intenzity EMP [V/m]"];

    attributeMapping={
        "sirokopasmove":["širokopásmové meranie","27.5"],
        "800":["800 MHz","38.9"],
        "900":["900 MHz","41.3"],
        "1800":["1800 MHz","59.1"],
        "2100":["2100 MHz","61"],
        "2600":["2600 MHz","61"],
        "3600":["3600 MHz","61"]
    }
    constructor(options) {

        super({
            element: document.createElement('div')
        });

        this.options = options;
        this.wmsLayer=options.wmsLayer;

        this.isActive = false;
        const self=this;

        const className = options.className !== undefined ? options.className : 'ol-popup';

        ///const cssClasses = className + ' ' + CLASS_UNSELECTABLE ;
        const container = document.createElement('div');
        container.className = className;
        container.id="popup";
        const btnDiv = document.createElement('div');
        btnDiv.className ="ol-popup-navigation";
        const popupPrev=document.createElement('a');
        popupPrev.setAttribute("href","#");
        popupPrev.title="Predchádzajúci";
        popupPrev.className="ol-popup-prev";


      /*  var container = document.getElementById('popup');
        this.popupContent = document.getElementById('popup-content');
        var popupCloser = document.getElementById('popup-closer');
        var popupPrev = document.getElementById('popup-prev');
        var popupNext = document.getElementById('popup-next');*/
        popupPrev.onclick = function () {
            self.prevClicked();
            popupPrev.blur();
            return false;
        }

        btnDiv.appendChild(popupPrev);

        this.featureIdLabel=document.createElement('span');
        this.featureIdLabel.className="ol-popup-feature-label";
        this.featureIdLabel.innerHTML=1;
        btnDiv.appendChild(this.featureIdLabel);
        //const self=this;
        const popupNext=document.createElement('a');
        popupNext.setAttribute("href","#");
        popupNext.title="Nasledujúci";
        popupNext.className="ol-popup-next";

        popupNext.onclick = function () {
            self.nextClicked();
            popupNext.blur();
            return false;
        }

        btnDiv.appendChild(popupNext);
        const popupCloser=document.createElement('a');
        popupCloser.setAttribute("href","#");
        popupCloser.title="Zatvoriť";
        popupCloser.className="ol-popup-closer";

        popupCloser.onclick = function () {
            self.popupClose();
            popupCloser.blur();
            return false;
        }

        container.appendChild(popupCloser);
        container.appendChild(btnDiv);

        this.popupContent= document.createElement('div');
        container.appendChild(this.popupContent);
        document.body.appendChild(container);


        this.overlay = new Overlay({
            element: container,
            autoPan: true,
            autoPanAnimation: {
                duration: 250,
            },
        });
    }
    enableMapClick() {
        const self=this;
        const map=self.getMap();
       return map.on('singleclick', function (evt) {

            var viewResolution = (map.getView().getResolution());
            var url = self.wmsLayer.getSource().getFeatureInfoUrl(
                evt.coordinate,
                viewResolution,
                'EPSG:3857',
                {'INFO_FORMAT': 'application/json',
                    'FEATURE_COUNT':20,'BUFFER':2}
            );
            if (url) {
                fetch(url)
                    .then(function (response) { return response.text(); })
                    .then(function (data) {
                        const jsonFormat= new GeoJSON();
                        const features=jsonFormat.readFeatures(data);
                        self.popupFeatures=[];
                        self.currentFeatureId=-1;

                        if (!features|| !features.length) {
                            self.popupClose();
                            return;
                        }
                        self.initPopup(features,evt.coordinate);
                    });
            }
        });
    }
    initPopup(features,coord) {

        this.popupFeatures=features;
        this.clickedCoordinates=coord;
        this.currentFeatureId=1;
        this.setLabel()
        this.showPopup(features[0],coord);

    }
    showPopup(feature) {
        const self = this;
        let coord=this.clickedCoordinates;
        let html = "";
        html += '<div class="feature-info-div"><table class="feature-info-table">';
        html += '<tr><td class="table-header">' + self.attributeHeader[0];
        html += '</td><td class="table-header">'+ self.attributeHeader[1]+'</td>';
        html += '<td class="table-header2">'+ self.attributeHeader[2]+'</td></tr>';
        //html += '<tr><td></td><td>[V/m]</td>';
        //html += '<td>[V/m]</td></tr>';
        const geom = feature.getGeometry();
        if (geom && geom.flatCoordinates){
            coord = [geom.flatCoordinates[0], geom.flatCoordinates[1]];
        }
        const props=feature.getProperties();
        for (let key in self.attributeMapping) {
            const header = self.attributeMapping[key][0];
            const limit=self.attributeMapping[key][1];
            html += '<tr>';
            html += '<td>' + header + '</td>';
            html+='<td>'+props[key]+'</td>';
            html+='<td>'+limit+'</td>';
            html += '</tr>';
        }
        html += '</table>';
        html += '</div>';
        this.popupContent.innerHTML = html;
        this.overlay.setPosition(coord);
    }
    activate () {
        const map=this.getMap();
        map.addOverlay(this.overlay);
        this.mapClickHandlerKey=  this.enableMapClick();
    }
    deactivate() {
        map.removeOverlay(this.overlay);
        unByKey(this.mapClickHandlerKey);
    }
    popupClose() {
        const self=this;
        self.overlay.setPosition(undefined);
        self.popupFeatures=[];
        self.currentFeatureId=-1;
    }
    prevClicked() {
        if (this.currentFeatureId==-1) return;
        const newId=this.currentFeatureId-1;
        if(newId<1) {
            this.currentFeatureId=this.popupFeatures.length;
        }
        else {
            this.currentFeatureId=newId;
        }
        this.setLabel();
        this.showPopup(this.popupFeatures[this.currentFeatureId-1]);
    }
    nextClicked() {
        if (this.currentFeatureId==-1) return;
        const newId=this.currentFeatureId+1;
        if(newId>this.popupFeatures.length) {
            this.currentFeatureId=1;
        }
        else {
            this.currentFeatureId=newId;
        }
        this.setLabel();
        this.showPopup(this.popupFeatures[this.currentFeatureId-1]);
    }
    setLabel() {
        const label= this.featureIdLabel;
        if(label) label.innerHTML=this.currentFeatureId;
    }
}